import React, { useEffect, useRef, useState } from 'react';
// Reusa o mesmo styled — UX e padrao visual sao identicos ao
// VariableMultiPicker (so o conceito do que se escolhe muda).
import * as s from '../variable-multi-picker/styled-variable-multi-picker';

// Picker multi-select pra comparar a MESMA variavel entre maquinas
// (things) diferentes da appliance. Ex.: vazao da TGA-1 vs TGA-2 vs
// TGA-3. Complementa o VariableMultiPicker (que compara variaveis
// diferentes na MESMA maquina).
//
// Layout/UX igual ao VariableMultiPicker (familiaridade pro operador).
// Diferenca: icone (lucide:cpu pra maquinas em vez de lucide:layers
// pra camadas) + label 'maquinas'.
const ThingMultiPicker = ({
  things = [],
  selectedThingIds = [],
  excludeThingIds = [],
  colorMap = {},
  // IDs (string ou number) das things atualmente em loading. Dot
  // vira spinner pra indicar fetch em progresso.
  loadingThingIds = [],
  max = 2,
  onChange,
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  // Filtra: exclui a thing primaria + qualquer outra excluida.
  // String comparison pra ser tolerante a id number vs string.
  const options = (things || []).filter(
    (t) =>
      t &&
      t.id != null &&
      !excludeThingIds.map(String).includes(String(t.id))
  );

  const isSelected = (id) => selectedThingIds.map(String).includes(String(id));
  const atMax = selectedThingIds.length >= max;

  const togglePick = (id) => {
    const sid = String(id);
    if (isSelected(id)) {
      onChange(selectedThingIds.filter((tid) => String(tid) !== sid));
    } else if (!atMax) {
      onChange([...selectedThingIds, id]);
    }
  };

  const selectedCount = selectedThingIds.length;

  return (
    <s.Container ref={containerRef}>
      <s.TriggerButton
        type="button"
        $active={selectedCount > 0}
        onClick={() => setOpen((v) => !v)}
        title={
          selectedCount > 0
            ? `${selectedCount} máquina(s) em comparação`
            : 'Comparar mesma variável em outras máquinas'
        }
      >
        {/* lucide:cpu — pega visualmente "outra unidade" (chip/maquina) */}
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
          <rect x="9" y="9" width="6" height="6" />
          <line x1="9" y1="1" x2="9" y2="4" />
          <line x1="15" y1="1" x2="15" y2="4" />
          <line x1="9" y1="20" x2="9" y2="23" />
          <line x1="15" y1="20" x2="15" y2="23" />
          <line x1="20" y1="9" x2="23" y2="9" />
          <line x1="20" y1="14" x2="23" y2="14" />
          <line x1="1" y1="9" x2="4" y2="9" />
          <line x1="1" y1="14" x2="4" y2="14" />
        </svg>
        máquinas
        {selectedCount > 0 && <s.Badge>{selectedCount}</s.Badge>}
      </s.TriggerButton>

      {open && (
        <s.Dropdown>
          <s.DropdownHeader>
            <s.DropdownTitle>Comparar máquinas</s.DropdownTitle>
            <s.DropdownHint>
              {selectedCount}/{max}
            </s.DropdownHint>
          </s.DropdownHeader>
          {options.length === 0 ? (
            <s.Empty>Sem outras máquinas disponíveis na appliance.</s.Empty>
          ) : (
            options.map((t) => {
              const sel = isSelected(t.id);
              const disabled = !sel && atMax;
              const color = colorMap[String(t.id)];
              const label = t.thing || t.description || `Máquina ${t.id}`;
              return (
                <s.Option
                  key={t.id}
                  type="button"
                  $selected={sel}
                  disabled={disabled}
                  onClick={() => togglePick(t.id)}
                  title={
                    disabled
                      ? `Máximo de ${max} máquinas em comparação atingido`
                      : sel
                      ? `Remover ${label} da comparação`
                      : `Adicionar ${label} à comparação`
                  }
                >
                  {sel &&
                  color &&
                  loadingThingIds.map(String).includes(String(t.id)) ? (
                    <s.DotSpinner color={color} />
                  ) : sel && color ? (
                    <s.ColorDot color={color} />
                  ) : (
                    <s.ColorDotPlaceholder />
                  )}
                  <s.OptionLabel>{label}</s.OptionLabel>
                </s.Option>
              );
            })
          )}
        </s.Dropdown>
      )}
    </s.Container>
  );
};

export default ThingMultiPicker;
